import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import { useState } from 'react';

const Wrapper = styled.div `
  margin-bottom: 8px;

  &.horizontal {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 8px;

    .label {
      margin-bottom: 0;
    }
  }
`;
const Label = styled.div(({ theme }) => `
flex: 1;
margin-bottom: 4px;
color: ${theme.pb.textColor};
font-size: 12px;
font-weight: 500;
`);
const Tip = styled.div(({ theme }) => `
  margin-bottom: 8px;
  color: ${theme.pb.secondaryTextColor};
  font-size: 13px;
`);
const WarningMessage = styled.div(({ theme }) => `
  margin-top: 4px;
  color: ${theme.pb.warningColor};
`);
const ErrorMessage = styled.div(({ theme }) => `
  margin-top: 4px;
  color: ${theme.pb.errorColor};
`);
const FormItem = ({ className, layout = 'horizontal', label, children, warning, tip, error, }) => {
    const [labelWidth, setLabelWidth] = useState();
    const getClassName = () => {
        let cls = layout;
        if (className) {
            cls += ` ${className}`;
        }
        return cls;
    };
    const getLabelWidth = (ele) => {
        if (ele && layout === 'horizontal') {
            setLabelWidth(ele.clientWidth);
        }
    };
    const getTextElement = () => {
        if (!warning && !error && (!tip || layout !== 'horizontal'))
            return null;
        const textContent = (jsxs(Fragment, { children: [tip && layout === 'horizontal' && jsx(Tip, { children: tip }), !!warning && jsx(WarningMessage, { children: warning }), error && jsx(ErrorMessage, { children: error })] }));
        if (layout === 'vertical')
            return textContent;
        return (jsx("div", Object.assign({ style: { marginLeft: `${labelWidth}px`, flexBasis: '100%' } }, { children: textContent })));
    };
    return (jsxs(Wrapper, Object.assign({ className: getClassName() }, { children: [!!label && (jsx(Label, Object.assign({ className: "label", ref: getLabelWidth }, { children: label }))), tip && layout === 'vertical' && jsx(Tip, { children: tip }), children, getTextElement()] })));
};

export { FormItem as F };
